module.exports = __webpack_public_path__ + "static/img/3.916989d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newOne/3.png
// module id = itpw
// module chunks = 0